import { initMenu } from './_menu'
import { initHeader } from './_header'
import { initSwipers } from './_swipers'
import { initBuyModal } from './_buy-modal'
import { initFilters } from './_filters'
import { initAccordions } from './_accordions'
import { initFancyBox } from './_fancybox'
import { initFAQs } from './_faqs'
import { initProduct } from './_product'
import { initAnimation } from './_animation'

import './_paver-calculator'
import './_pebbles-calculator'
import './_side-panels'
import './_custom-elements'

const initializeModule = (name, initFn) => {
  try {
    console.log(`Initializing module: ${name}`);
    initFn();
    console.log(`Successfully initialized: ${name}`);
  } catch (error) {
    console.error(`Error initializing ${name}:`, error);
  }
};

const initApp = () => {
  const modules = [
    { name: 'Menu', init: initMenu },
    { name: 'Header', init: initHeader },
    { name: 'Swipers', init: initSwipers },
    { name: 'Filters', init: initFilters },
    { name: 'Accordions', init: initAccordions },
    { name: 'FancyBox', init: initFancyBox },
    { name: 'BuyModal', init: initBuyModal },
    { name: 'FAQs', init: initFAQs },
    { name: 'Product', init: initProduct },
    { name: 'Animation', init: initAnimation }
  ];

  modules.forEach(({ name, init }) => initializeModule(name, init));
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}